<template lang="pug">
  .error-box
    .empty
      .empty-icon
        i(:class="params.icon")
      p.empty-title.h5 {{ params.title }}
      p.empty-subtitle {{ error.message }}
      .empty-action
        slot(name="action")
</template>

<script>
import mapErrors from './mapErrors'

export default {
  props: {
    error: { type: Object, required: true },
  },
  computed: {
    params() {
      const map = mapErrors[this.error.code]
      return (
        map || {
          title: 'Algo deu errado',
          icon: 'fas fa-times fa-4x text-error',
        }
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
.error-box
  height calc(100vh - 240px)
  display flex
  flex-direction column
  align-items center
  justify-content center

  .empty
    width 40%
    max-width 500px
    min-width 300px
</style>
